import { EmployeeCell } from "components/cell/employee/cell";
import DirectusAdvancedTable from "components/directus/advanced-table";
import DirectusBasicList from "components/directus/basic-list";
import { DirectusForm } from "directus-form";
import GlobalSearch from "@/components/global-search";
import React from "react";
import client from "directus/src/client";

export default function DirectusUILibrary() {
  return (
    <div className="p-4 flex-1 overflow-auto">
      {/* <DirectusAdvancedTable
        collection="projects"
        client={client}
        // fields={[
        //   "name",
        //   "description",
        //   "coordinator",
        //   { coordinator: ["id", "avatar", "first_name", "last_name"] },
        // ]}
        // columns={[
        //   { id: "name", header: "Name", accessorKey: "name" },
        //   // {
        //   //   id: "description",
        //   //   header: "Description",
        //   //   accessorKey: "description",
        //   // },
        //   {
        //     id: "coordinator",
        //     header: "Coordinator",
        //     accessorKey: "coordinator",
        //     cell: EmployeeCell,
        //   },
        // ]}
      /> */}
      {/* <DirectusBasicList client={client} collection="jobs" fields={["name"]} /> */}
      <div className="max-w-xl">
        <DirectusForm
          client={client}
          collection="domain_services"
          // defaultValues={{ job: "4ec9c9b0-c631-444e-97b5-cf2b875cc9c6" }}
          showTitle={true}
          // itemId={"4e0c74d4-e713-46ca-b427-a32bb08a51f5"}
          // title="Add New Skill"
          // description="Create a new skill entry with automatic field generation"
          columns={2}
          spacing="normal"
          excludeFields={["platform"]}
          onSuccess={(result) => {
            console.log("Skill created:", result);
            alert("Skill created successfully!");
          }}
          onError={(error) => {
            console.error("Form error:", error);
            alert("Error creating skill: " + error.message);
          }}
        />
      </div>
      {/* <GlobalSearch /> */}
    </div>
  );
}
